// @flow
import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { DataFetcherContainer } from '../../presentational/DataFetcherContainer';
import { useGetNativeInferencePoolMonthlySpendSummaryQuery } from '../../../service-definitions/estimates';
import { MonthlySpendSummaryContainer } from '../../common/MonthlySpendSummaryContainer';
import { convertToArrayIfNotArray } from '../../../common-utils/utils';

export const NativeInferencePoolMonthlySpendSummaryContainer = ({ disabled }) => {
  const { estimateId, nativeInferencePoolId } = useParams();

  return (
    <DataFetcherContainer
      dataFetchingArgs={useMemo(
        () => [
          { estimateId: estimateId, nativeInferencePoolId: nativeInferencePoolId },
          {
            skip: !estimateId || !nativeInferencePoolId,
          },
        ],
        [nativeInferencePoolId, estimateId]
      )}
      dataFetchingFunction={useCallback(useGetNativeInferencePoolMonthlySpendSummaryQuery, [])}
    >
      {(data) => {
        const monthlySpendSummary = convertToArrayIfNotArray(data.monthly_spend);
        return (
          <MonthlySpendSummaryContainer
            disabled={disabled}
            monthlySpendSummary={monthlySpendSummary}
          />
        );
      }}
    </DataFetcherContainer>
  );
};
